import { useCallback, useState } from 'react';

const DEFAULT_OPTIONS = {
  enableHighAccuracy: true,
  timeout: 20000,
  maximumAge: 60000,
};

export const useCurrentLocation = ({ onSuccess, onError, options = DEFAULT_OPTIONS } = {}) => {
  const [locLoading, setLocLoading] = useState(false);

  const captureCurrentLocation = useCallback(() => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      if (typeof onError === 'function') {
        onError('Location is not supported in this browser.');
      }
      return;
    }

    setLocLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocLoading(false);
        const latitude = Number(position.coords.latitude).toFixed(8);
        const longitude = Number(position.coords.longitude).toFixed(8);
        if (typeof onSuccess === 'function') {
          onSuccess({ latitude, longitude, position });
        }
      },
      (error) => {
        setLocLoading(false);
        const denied = error && (error.code === 1 || error.code === error.PERMISSION_DENIED);
        if (typeof onError === 'function') {
          onError(
            denied
              ? 'Location permission was denied. Enable it in your browser or device settings.'
              : error?.message || 'Could not get your location.',
          );
        }
      },
      options,
    );
  }, [onError, onSuccess, options]);

  return { locLoading, captureCurrentLocation };
};

